export const pipesI18NPl = {
    today: "Dzisiaj",
    yesterday: "Wczoraj",
};
